import { useState } from 'react';

const useProgramaPeriodoModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const open = (reportData) => {
    const hoje = new Date();
    const anoBase = parseInt(localStorage.getItem('anoBase')) || hoje.getFullYear();
    const dataInicio = `${anoBase}-01-01`;
    const dataFim = `${anoBase}-12-31`;

    setData({
      ...reportData,
      dataInicio,
      dataFim,
      programa: null,
    });
    setIsOpen(true);
    setIsLoading(false);
  };

  const close = () => {
    setIsOpen(false);
    setData(null);
    setIsLoading(false);
  };

  const confirm = () => {
    close();
  };

  const updateProgramaAndDatas = (programa, dataInicio, dataFim) => {
    setData(prev => ({
      ...prev,
      programa,
      dataInicio,
      dataFim,
    }));
  };

  const setLoading = (loading) => {
    setIsLoading(loading);
  };

  return {
    show: isOpen,
    data,
    open,
    close,
    confirm,
    updateProgramaAndDatas,
    isLoading,
    setLoading,
  };
};

export default useProgramaPeriodoModal;
